import { Typography } from 'components/generic/typography';
import TrackingContext from 'modules/tracking/GA4/helpers/TrackingContext';
import type {
    TypeArticleTemplateDetailed,
    TypeSectionTemplateDetailed,
    TypeStandardTemplateDetailed,
    TypeWebpageDetailed
} from 'types/autogen/contentful';
import ContentfulContext from './ContentfulContext';
import ArticleTemplate from './components/ArticleTemplate';
import JsonLd from './components/JsonLd';
import SectionTemplate from './components/SectionTemplate';
import StandardTemplate from './components/StandardTemplate';

function RenderTemplate({
    content,
    isPreview
}: {
    content: TypeWebpageDetailed['fields']['template'];
    isPreview: boolean;
}) {
    const contentType = content?.sys.contentType.sys.id;
    if (!contentType) return null;

    if (!content?.fields?.isPublished && !isPreview) return null;

    switch (contentType) {
        case 'articleTemplate':
            return <ArticleTemplate {...(content as TypeArticleTemplateDetailed)} />;
        case 'sectionTemplate':
            return <SectionTemplate {...(content as TypeSectionTemplateDetailed)} />;
        case 'standardTemplate':
            return <StandardTemplate {...(content as TypeStandardTemplateDetailed)} />;
        case 'productListTemplate':
            return isPreview ? <Typography.Title size="L">Slug not matching a product list</Typography.Title> : null;
        default:
            return null;
    }
}

export default function ContentfulPage({
    model,
    isPreview = false
}: {
    model: TypeWebpageDetailed[];
    isPreview?: boolean;
}) {
    const { template, jsonLd } = model[0].fields;
    if (!template) return null;

    const templateType = template?.sys.contentType.sys.id;

    return (
        <ContentfulContext.Provider value={{ template: templateType }}>
            <TrackingContext context="contentful">
                {jsonLd && <JsonLd {...jsonLd} />}
                <RenderTemplate content={template} isPreview={isPreview} />
            </TrackingContext>
        </ContentfulContext.Provider>
    );
}
